import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

type Callback = (id: string) => void;

const useHttpApproveMedicalLeaveRequest = () => {
    const { t } = useTranslation('medicalLeaveRequest');
    const userApi: UserApi = useContainer(UserApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const approveMedicalLeaveRequest = (id: string, callback: Callback) => {
        const { exec, abort } = userApi.approve({
            params: { id },
            onSuccess: () => {
                toastHandler.push(
                    `success`,
                    t('notifications.approveMedicalLeaveRequestTitle'),
                    t('notifications.approveMedicalLeaveRequestSucceededMessage')
                );
                callback(id);
            },
            onError: () => {
                toastHandler.push(
                    `error`,
                    t('notifications.approveMedicalLeaveRequestTitle'),
                    t('notifications.approveMedicalLeaveRequestFailedMessage')
                );
            },
        });
        exec();
        return abort;
    };

    return { approveMedicalLeaveRequest };
};

export default useHttpApproveMedicalLeaveRequest;
